import { Component } from "@angular/core"

@Component({
  imports: [],
  standalone: true,
  template: `
    <p>
      util-analytics works!
    </p>
  `,
  selector: "lib-util-analytics",
})
export class UtilAnalyticsComponent {
}
